/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Button, ButtonGroup, StyledModal, ModalActions, Text } from 'sarsaparilla';

interface FavoriteHeartRemoveAllModalProps {
    isRemoveAllModalOpen: boolean;
    setIsRemoveAllModalOpen: (isOpen: boolean) => void;
    dismissModal: () => void;
    loading: boolean;
    removeFromFavorites: () => void;
}

export function FavoriteHeartRemoveAllModal({
    isRemoveAllModalOpen,
    setIsRemoveAllModalOpen,
    dismissModal,
    loading,
    removeFromFavorites,
}: FavoriteHeartRemoveAllModalProps) {
    return (
        <StyledModal
            heading={''}
            size="md"
            isOpen={isRemoveAllModalOpen}
            overlayClassName="sui-favorites-modal-wrap"
            onRequestClose={dismissModal}
            shouldActionsStickInMobile
        >
            <div style={{ display: 'grid', placeItems: 'center' }} className="my-10">
                <Text size="xl" fontWeight="semibold">
                    Are you sure you want to remove this item from all lists?
                </Text>
            </div>

            <ModalActions>
                <ButtonGroup>
                    <Button
                        appearance={'tertiary'}
                        gaTrackingId="199951850105"
                        gaTrackingValue="Remove From All Lists Back Button"
                        onClick={() => {
                            setIsRemoveAllModalOpen(false);
                        }}
                    >
                        Back
                    </Button>
                    <Button
                        onClick={() => {
                            removeFromFavorites();
                        }}
                        appearance="danger"
                        isLoading={loading}
                        isDisabled={loading}
                        gaTrackingId="199951850105"
                        gaTrackingValue="Remove From All Button"
                    >
                        Remove
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
